// extracted by mini-css-extract-plugin
export default {"advertCardHeader":"c-a_iU","advertCardHeader__actions":"c-a_iV","advertCardHeader__bottomLabel":"c-a_iW"};